import { motion } from "motion/react"

const DISPLAY = "'Tilda Sans', sans-serif"
const BODY = "'Manrope', sans-serif"
const MONO = "'JetBrains Mono', monospace"

const SECTIONS = [
    {
        icon: "🎬",
        title: "Что такое Мягкий кинотеатр",
        text: "Мягкий кинотеатр — это уютный зал с мягкими диванами и кресла-мешками вместо стандартных кресел. Смотри кино с максимальным комфортом — ляг, возьми плед и наслаждайся.",
    },
    {
        icon: "📱",
        title: "QR-вход в зал",
        text: "Покупай билеты онлайн и входи в зал по QR-коду прямо из этого приложения. Никаких очередей и распечаток — просто покажи экран на входе.",
    },
    {
        icon: "💎",
        title: "Программа бонусов",
        text: "За каждый купленный билет начисляем кинобонусы. Накопи бонусы и используй их для оплаты следующих сеансов. 1 бонус = 1 рубль скидки.",
    },
    {
        icon: "🎟",
        title: "Пушкинская карта",
        text: "Принимаем оплату Пушкинской картой на отечественные фильмы и спектакли. Смотри отечественное кино за счёт государства.",
    },
    {
        icon: "📍",
        title: "Где нас найти",
        text: "Мягкий кинотеатр · MEGA, Копейское шоссе, 64, Челябинск. Рядом с торговым центром MEGA, парковка бесплатная.",
    },
]

export default function About() {
    return (
        <div className="flex flex-col gap-6">
            <h2
                className="text-white"
                style={{ fontFamily: DISPLAY, fontWeight: 800, fontSize: 24, letterSpacing: "-0.01em" }}>
                ℹ️ Справка
            </h2>

            <div className="flex flex-col gap-4">
                {SECTIONS.map((section, i) => (
                    <motion.div
                        key={section.title}
                        initial={{ opacity: 0, y: 16 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ delay: i * 0.07 }}
                        viewport={{ once: true }}
                        className="rounded-[22px] border border-white/10 bg-white/[0.05] p-6 flex flex-col gap-3">
                        <div className="flex items-center gap-3">
                            <span className="text-[22px]">{section.icon}</span>
                            <h3
                                className="text-white"
                                style={{ fontFamily: DISPLAY, fontWeight: 700, fontSize: 15, letterSpacing: "-0.01em" }}>
                                {section.title}
                            </h3>
                        </div>
                        <p className="text-white/55 text-[14px] leading-relaxed" style={{ fontFamily: BODY }}>
                            {section.text}
                        </p>
                    </motion.div>
                ))}
            </div>

            <div className="flex justify-center pt-2">
                <p className="text-white/20 text-[11px]" style={{ fontFamily: MONO }}>
                    Мягкий кинотеатр · v2.0
                </p>
            </div>
        </div>
    )
}
